export const config = {
  title: "LML Mobile Services | Mobile Maintenance, Pressure Washing & Towing in Mount Orab, OH",
  meta: {
    description:
      "LML Mobile Services provides mobile maintenance, pressure washing, and towing services across Ohio, Kentucky, and Indiana. Based in Mount Orab, OH, we deliver professional and reliable service wherever you need us.",
    keywords: [
      "LML Mobile Services",
      "mobile maintenance",
      "pressure washing",
      "towing service",
      "fleet maintenance",
      "Mount Orab Ohio",
      "vehicle repair",
      "mobile services Ohio Kentucky Indiana"
    ],
    author: "LML Mobile Services",
    canonicalUrl: "https://www.lmlmobileservices.com/",
  },
  sections: {
    header: {
      businessName: "LML Mobile Services",
    },
    sectionB: {
      heroTitle: "Reliable Mobile Services at Your Doorstep",
      heroSubtitle: "Maintenance, Pressure Washing & Towing Across Ohio, Kentucky & Indiana",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "5139100376",
      phoneLabel: "(513) 910-0376",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1219980553/photo/online-news-on-a-smartphone-and-laptop-woman-reading-news-or-articles-in-a-mobile-phone.jpg?s=612x612&w=0&k=20&c=QodY8pXN5DbLs3-FhwWhhYKnsOE4Iixky_SwdGitwnQ=",
      cardData: [
        {
          title: "Mobile Maintenance",
          description:
            "Preventive inspections, follow-up repairs, and scheduled maintenance brought directly to you.",
        },
        {
          title: "Pressure Washing",
          description:
            "Professional pressure washing for fleets, vehicles, and equipment to keep them looking sharp.",
        },
        {
          title: "Towing Service",
          description:
            "Reliable towing and roadside assistance when you need it most.",
        },
      ],
      description:
        "LML Mobile Services is your trusted partner for mobile vehicle maintenance, towing, and pressure washing. Serving Ohio, Kentucky, and Indiana, we ensure your vehicles and fleets stay in top condition.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Explore our wide range of mobile and on-site services designed to keep your vehicles and property in excellent condition.",
      cards: [
        {
          title: "Mobile Maintenance",
          description:
            "On-site inspections, repairs, and scheduled fleet maintenance.",
          imageSrc: "https://media.istockphoto.com/id/1369375235/photo/technician-disassembling-smartphone-with-screwdriver.jpg?s=612x612&w=0&k=20&c=xQhoOfEfm7ORtiC22nl2HTRfp4x11nJmdWV8c3yVvjs=",
          imageAlt: "Mobile Maintenance Service",
        },
        {
          title: "Pressure Washing",
          description:
            "High-quality pressure washing for vehicles, equipment, and more.",
          imageSrc: "https://media.istockphoto.com/id/163524134/photo/mobile-phone-service.jpg?s=612x612&w=0&k=20&c=W9Swx45SLffDP17O2KzQUTiXMrowumLqf-uaEAvjGhk=",
          imageAlt: "Pressure Washing Service",
        },
        {
          title: "Towing Service",
          description:
            "Fast and reliable towing service across the tri-state region.",
          imageSrc: "https://media.istockphoto.com/id/466387691/photo/tow-truck-wreck.jpg?s=612x612&w=0&k=20&c=xgx9vJb-9C82Jp3MEUvgax-q_FcpdOU29BdG6Pj1RRc=",
          imageAlt: "Towing Service",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Emergency Roadside Assistance",
        "Fleet Inspections",
        "Mobile Oil Change",
      ],
    },
    sectionD: {
      aboutTitle: "About LML Mobile Services",
      aboutImage: {
        src: "https://static.wixstatic.com/media/dcb226_85e36cd848ab45c3b7a7668cdec8e0ba~mv2.jpeg/v1/fill/w_644,h_455,al_c,q_80,enc_avif,quality_auto/dcb226_85e36cd848ab45c3b7a7668cdec8e0ba~mv2.jpeg",
        alt: "LML Mobile Services Team",
      },
      aboutText: [
        "LML Mobile Services is dedicated to providing professional mobile maintenance, pressure washing, and towing solutions. Based in Mount Orab, OH, we proudly serve customers across Ohio, Kentucky, and Indiana.",
        "Our team is committed to delivering reliable service, affordable solutions, and exceptional care for vehicles and fleets of all sizes.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "LML Mobile Services Logo",
      businessName: "LML Mobile Services",
      contact: {
        phone: "5139100376",
        phoneLabel: "(513) 910-0376",
        email: "Loganleach2@gmail.com",
        website: "https://www.lmlmobileservices.com/",
        address: "777 S High St, Mount Orab, OH 45154",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "777 S High St, Mount Orab, OH 45154",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.145123456789!2d-83.9212!3d39.0279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8840f123456789ab%3A0xabcdef123456789!2s777%20S%20High%20St%2C%20Mount%20Orab%2C%20OH%2045154!5e0!3m2!1sen!2sus!4v1712345678901!5m2!1sen!2sus",
    },
  },
};

export default config;
